import { render, staticRenderFns } from "./login-footer-icons.vue?vue&type=template&id=e382ee64&scoped=true"
import script from "./login-footer-icons.vue?vue&type=script&lang=js"
export * from "./login-footer-icons.vue?vue&type=script&lang=js"
import style0 from "./login-footer-icons.vue?vue&type=style&index=0&id=e382ee64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e382ee64",
  null
  
)

export default component.exports